import CheckboxComp from './Checkbox';
import CheckboxColsComp from './CheckboxCols';
import BadgeGroupComp from './BadgeGroup';
import ToggleComp from './Toggle';
import SalaryRangeComp from './SalaryRange';
import SelectSortableListComp from './SelectSortableList';
import OnOffToggleComp from './OnOffToggle';
import RadioComp from './Radio';
import UploadButtonComp from './UploadButton';
export var Checkbox = CheckboxComp;
export var CheckboxCols = CheckboxColsComp;
export var BadgeGroup = BadgeGroupComp;
export var Toggle = ToggleComp;
export var SalaryRange = SalaryRangeComp;
export var SelectSortableList = SelectSortableListComp;
export var OnOffToggle = OnOffToggleComp;
export var Radio = RadioComp;
export var UploadButton = UploadButtonComp;